import React, { useState, Alert, P, BR, SPAN, FONT, B } from 'react';
import api from '../../services/api';
import $ from 'jquery';
import FirebaseService from '../../services/firebase';
import "./style.css";
import logo from '../../assets/logo.anonymo.png'
import appStore from '../../assets/appStore.png'
import playStore from '../../assets/playStore.png'

export default function Home({ history }) {

    function openUrl(url) {
        window.open(url,"_self")
    }


    return (
        <div className="home-body">
            <div className="logo"><img className="logo" src={logo} />
                <p className="text">Anonymo App</p>
            </div>
            <div class="logo-stores">
                <button onClick={() => openUrl('https://apps.apple.com/us/app/anonymo/id1476883744')}>
                    <img class="logo" src={appStore} />
                </button>
                <button onClick={() => openUrl('https://play.google.com/store/apps/details?id=com.anonymo.anonymoapp')}>
                    <img class="logo" src={playStore} />
                </button>
            </div>
            <div className="text">
                <p>SOMOS UMA COMUNIDADE DIGITAL DE MILHARES DE PESSOAS QUE SE AJUDAM DIARIAMENTE NA LUTA CONTRA SUAS
                    DEPENDÊNCIAS</p>
                <p>Álcool, drogas, co-dependentes, cigarro, jogos, comer compulsivamente, relacionamentos tóxicos,
                    depressão, pornografia entre outras categorias...</p>
                <p>Baixe grátis agora mesmo e ajude-nos a te ajudar!.</p>
            </div>
        </div>
    )
}